document.addEventListener("DOMContentLoaded", function () {
    const toggleBtn = document.querySelector(".driveworks-header .toggle");
    const menuContainer = document.querySelector(".driveworks-menu-container");
    const pageContainer = document.querySelector("#page");
  
    function adjustMenuOffset() {
      const driveworksheader = document.querySelector('#driveworks-header');
      const offset = driveworksheader ? driveworksheader.offsetHeight
      : 0;
      if (menuContainer) {
        menuContainer.style.top = offset + 'px';
      }
    }
  
    if (toggleBtn && pageContainer && menuContainer) {
      toggleBtn.addEventListener("click", function () {
        pageContainer.classList.toggle("menu-open");
        if (pageContainer.classList.contains("menu-open")) {
          adjustMenuOffset(); // apply offset only when opening
        }
      });
    }
  });


  document.addEventListener("DOMContentLoaded", function () {
    const pageContainer = document.querySelector("#page");
  
    function removeMenuOpenIfDesktop() {
      if (window.innerWidth > 768) {
        pageContainer.classList.remove("menu-open");
      }
    }
  
    // Debounce helper
    function debounce(func, wait = 200) {
      let timeout;
      return function (...args) {
        clearTimeout(timeout);
        timeout = setTimeout(() => func.apply(this, args), wait);
      };
    }
  
    const debouncedResizeOrScroll = debounce(removeMenuOpenIfDesktop, 300);
  
    // Bind to both resize and scroll
    window.addEventListener("resize", debouncedResizeOrScroll);
    window.addEventListener("scroll", debouncedResizeOrScroll);
  });


/*   const URL_QUERY = new URLSearchParams(window.location.search);
  const ABOUT_DISMISSED_KEY = "aboutDismissed";
 */  

  let site;
  
  class Site {
      constructor() {
          this._basketQuantityElement = document.querySelector("[data-basket-quantity]");
      }
  
      init() {
          
          
          this.storeUtmValues();
          this.displayBasketQuantity();
      }
  
     
  

      storeUtmValues() {
        const URL_QUERY = new URLSearchParams(window.location.search);
          const urlReferralSource = URL_QUERY.get("dw_source");
  
          if (urlReferralSource) {
              localStorage.setItem("teamId", urlReferralSource);
          }
      }
  
      displayBasketQuantity() {

        if (this._basketQuantityElement) {
          const value = localStorage.getItem("basketQuantity") || 0;
  
          this._basketQuantityElement.innerHTML = value;
          this._basketQuantityElement.classList.toggle("opacity-0", value == 0);
        }

          
      }
  }
  
  (async () => {
      site = new Site();
      site.init();
  })();